<template>
<div @keyup.esc="loadProduct()" >
  <v-toolbar color="white" flat>
    <v-btn icon @click="setStep(1)">
      <v-icon>arrow_back_ios</v-icon>
    </v-btn>
  </v-toolbar>
  <v-card>
    <v-card-title primary-title>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <h1><span class="orange--text" v-if="selectedProduct.pair == 1">(P) </span>{{selectedProduct.serial_number}}</h1>
          </v-flex>
          <v-flex xs12>
            <span class="font-weight-black text-xs-right">
                <v-dialog v-model="descriptionDialog" max-width="500px">
                <v-icon slot="activator">create</v-icon>
                <v-form  v-model="descriptionValid" onSubmit="return false;">
                <v-card>
                  <v-card-title primary-title>
                    <h1>Descripción</h1>
                  </v-card-title>

                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field v-model="selectedProduct.description" v-on:keyup.13="updateDescription"
                          label="Descripción" :rules="required" ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="closeDescription">Cancelar</v-btn>
                    <v-btn color="blue-grey darken-2 white--text" @click="updateDescription" :disabled="!valid">Guardar</v-btn>
                  </v-card-actions>
                </v-card>
                </v-form>
              </v-dialog>
            </span>
            <span class="headline" v-if="selectedProduct.description">  {{selectedProduct.description}}  </span>
            <span class="headline grey-text" v-else >  -- Descripción --  </span>
            </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs1>
            <h1>$</h1>
          </v-flex>
          <v-flex xs11>
            <v-layout row wrap>
              <v-flex xs12 class="text-xs-right">
                Precio<br/>
              </v-flex>
            </v-layout >
            <v-layout row wrap justify-end>
              <v-flex xs3 sm3 md3 lg2 >
                  <v-checkbox label="Manual" v-model="selectedProduct.manual_update" @click="removeMark"></v-checkbox>
              </v-flex>
              <v-flex xs9 sm3 md3 lg2  mt-3 class="text-xs-right">
                <span class="orange--text font-weight-black text-xs-right headline">
                  {{selectedProduct.avg_price | currency}}
                </span>
                <span class="font-weight-black text-xs-right">
                   <v-dialog v-model="dialog" max-width="500px">
                    <v-icon slot="activator">create</v-icon>
                    <v-form  v-model="valid" onSubmit="return false;">
                    <v-card>
                      <v-card-title primary-title>
                        <h1>Asignar Precio</h1>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12 sm6>
                              <v-text-field v-model="newPrice.pesosPrice" v-on:keyup.13="updatePrice"
                              label="Pesos" :rules="required" ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                              <v-text-field v-model="newPrice.dollarPrice" v-on:keyup.13="updatePrice"
                              label="Dolares" :rules="required" ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="close">Cancelar</v-btn>
                        <v-btn color="blue-grey darken-2 white--text" @click="updatePrice" :disabled="!valid">Guardar</v-btn>
                      </v-card-actions>
                    </v-card>
                    </v-form>
                  </v-dialog>
                </span>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-end>

              <v-flex xs4 class="text-xs-right">
                {{selectedProduct.min_price | currency}}
              </v-flex>
              <v-flex xs1>
                <v-icon color="red" pt-1>arrow_drop_down</v-icon>
              </v-flex>

              <v-flex xs4 class="text-xs-right">
                {{selectedProduct.max_price | currency}}
              </v-flex>
              <v-flex xs1>
                <v-icon color="green" pt-1>arrow_drop_up</v-icon>
              </v-flex>
              <v-flex xs2 class="text-xs-right">
                {{selectedProduct.price_ratio | currency('',0)}} %
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider inset></v-divider>
        <v-layout row wrap>

          <v-flex xs1>
            <h1>Peso</h1>
          </v-flex>
          <v-flex xs11>
            <v-layout row wrap>
              <v-flex xs12 class="text-xs-right">
                Promedio<br/>
                <span class="font-weight-black headline">{{selectedProduct.avg_weigth | currency('',0)}} gr</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-end>

              <v-flex xs4 class="text-xs-right">
                {{selectedProduct.min_weigth | currency('',0)}}
              </v-flex>
              <v-flex xs1>
                <v-icon color="red" pt-1>arrow_drop_down</v-icon>
              </v-flex>
              <v-flex xs4 class="text-xs-right">
                {{selectedProduct.max_weigth | currency('',0)}}
              </v-flex>
              <v-flex xs1>
                <v-icon color="green" pt-1>arrow_drop_up</v-icon>
              </v-flex>
              <v-flex xs2 class="text-xs-right">
                {{selectedProduct.weigth_ratio | currency('',0)}} %
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-title>

    <v-form @submit="updateItem" v-model="valid" ref="updateItemForm" onSubmit="return false;">
      <v-card-text>
        <v-card flat>
          <v-layout row wrap>
            <v-flex xs4 md4 centered>

            </v-flex>
            <v-flex xs2 md2>

            </v-flex>
            <v-flex xs2 md2>

            </v-flex>
            <v-flex xs2>
              <span class="title">Act.</span>
            </v-flex>
            <v-flex xs2>
              <span class="title">Par.</span>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
        </v-card>
        <v-card flat v-for="p in products" :key="p.product_id">
          <v-layout row wrap>
            <v-flex xs4 md4 centered>
              <v-flex xs1>
                {{p.product_id}}
              </v-flex>
              <v-flex xs11 pt-1 pl-1>
                <v-layout align-center justify-center row fill-height>
                  <v-img v-if="pictures[p.picture_path]" v-bind:src="pictures[p.picture_path]" height="100" contain />
                  <v-img v-else src="/img/img_not_found.png" height="125" contain></v-img>
              </v-layout>
              </v-flex>
            </v-flex>
            <v-flex xs4>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <span class="grey--text">Precio</span><br/>
                  {{p.pesos_price | currency}}
                </v-flex>
                <v-flex xs12 sm6>
                  <span class="grey--text">Peso</span><br/>
                  {{p.weigth_grams | currency('', 0)}}
                </v-flex>
                <v-flex xs5 sm3>
                  <span class="grey--text hidden-sm-and-down">Platino</span>
                  <span class="grey--text hidden-md-and-up">Pt</span><br/>
                  <v-text-field type="number" v-model="p.total_pt" />
                </v-flex>
                <v-flex xs1 />
                <v-flex xs5 sm3>
                  <span class="grey--text hidden-sm-and-down">Paladio</span>
                  <span class="grey--text hidden-md-and-up">Pd</span><br/>
                  <v-text-field type="number" v-model="p.total_pd"/>
                </v-flex>
                <v-flex xs1 />
                <v-flex xs5 sm3>
                  <span class="grey--text hidden-sm-and-down">Rodio</span>
                  <span class="grey--text hidden-md-and-up">Rh</span><br/>
                  <v-text-field type="number" v-model="p.total_rh" />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs2>
              <v-checkbox v-model="p.status" true-value="ACTIVE" false-value="INACTIVE"></v-checkbox>
            </v-flex>
            <v-flex xs2>
              <v-checkbox v-model="p.pair" :true-value="1" :false-value="0"></v-checkbox>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-btn icon @click="setStep(1)">
          <v-icon>arrow_back_ios</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" type="submit">Guardar</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</div>
</template>

<script>

import { getNewPricesForRow } from '../../utils/MetalPriceUtils';
import { changeDescription } from '../../services/products';

export default {
  props: ['product'],
  data() {
    return {
      selectedProduct: {
        price_ratio: 0.0,
        weigth_ratio: 0.0,
        serial_number: '',
        samples: 0,
        avg_price: 0.0,
        min_price: 0.0,
        max_price: 0.0,
        avg_weigth: 0.0,
        min_weigth: 0.0,
        max_weigth: 0.0,
        pair: undefined,
        description: '',
      },
      newPrice: {
        pesosPrice: 0.00,
        dollarPrice: 0.00,
      },
      products: [],
      pictures: [],
      valid: true,
      sortedPrice: 0,
      sortedWeigth: 0,
      dialog: false,
      valid: true,
      solo: true,
      required: [
        (v) => !!v || 'Campo requerido',
      ],
      descriptionDialog: false,
      descriptionValid: true,
    };
  },
  watch: {
    product(newVal, oldVal) {
      this.loadProduct();
    },
    products: {
      handler(newVal, oldVal) {
        let counter = 0;
        let sumPrice = 0;
        let maxPrice = 0;
        let minPrice = 0;
        let sumWeigth = 0;
        let maxWeigth = 0;
        let minWeigth = 0;
        const store = this.$store;
        newVal.forEach((product) => {
          // Update prices
          this.updatePrices(product, store);
          if (product.status === 'ACTIVE' && product.pair === this.selectedProduct.pair) {
            counter++;
            if (counter === 1) {
              maxPrice = product.pesos_price;
              minPrice = product.pesos_price;
              maxWeigth = product.weigth_grams;
              minWeigth = product.weigth_grams;
            }
            sumPrice = sumPrice + product.pesos_price;
            if (maxPrice < product.pesos_price) {
              maxPrice = product.pesos_price;
            }
            if (minPrice > product.pesos_price) {
              minPrice = product.pesos_price;
            }
            sumWeigth = sumWeigth + product.weigth_grams;
            if (maxWeigth < product.weigth_grams) {
              maxWeigth = product.weigth_grams;
            }
            if (minWeigth > product.weigth_grams) {
              minWeigth = product.weigth_grams;
            }
          }
        });

        this.selectedProduct.samples = counter;

        // Update the prices of the group
        if (!this.selectedProduct.manual_update) {
          this.selectedProduct.avg_price = sumPrice / counter;
        } else {
          this.selectedProduct.avg_price = this.selectedProduct.pesos_price;
        }
        this.selectedProduct.min_price = minPrice;
        this.selectedProduct.max_price = maxPrice;
        this.selectedProduct.price_ratio = minPrice * 100 / maxPrice;
        this.selectedProduct.avg_weigth = sumWeigth / counter;
        this.selectedProduct.min_weigth = minWeigth;
        this.selectedProduct.max_weigth = maxWeigth;
        this.selectedProduct.weigth_ratio = minWeigth * 100 / maxWeigth;

      },
      deep: true,
    },
  },
  methods: {
    // Update the prices of the given row (used for calculate the prices of the samples
    updatePrices(product, store) {
      product.pondered_total_pt = product.total_pt * 0.96;
      product.pondered_total_pd = product.total_pd * 0.96;
      product.pondered_total_rh = product.total_rh * 0.98;
      const newPrices =
        getNewPricesForRow(product, store.state.product.currentBasePrices , store.state.product.currentFactors);
      product.pesos_price = newPrices.newValues.pesos_price;
    },
    sortByPriceDesc() {
      this.products.sort((a, b) =>
        (a.pesos_price < b.pesos_price) ? 1 : ((b.pesos_price < a.pesos_price) ? -1 : 0));
      this.sortedPrice = -1;
      this.sortedWeigth = 0;
    },
    sortByWeigthDesc() {
      this.products.sort((a, b) =>
        (a.weigth_grams < b.weigth_grams) ? 1 : ((b.weigth_grams < a.weigth_grams) ? -1 : 0));
      this.sortedPrice = 0;
      this.sortedWeigth = -1;
    },
    updateItem() {
      const updateData = [];
      this.products.forEach((item) => {
        updateData.push({
          id: item.product_id,
          status: item.status,
          pair: item.pair,
          serial_number: item.serial_number,
          total_pt: item.total_pt,
          total_pd: item.total_pd,
          total_rh: item.total_rh,
          pondered_total_pt: item.pondered_total_pt,
          pondered_total_pd: item.pondered_total_pd,
          pondered_total_rh: item.pondered_total_rh,
        });
      });

      this.axios.put('/catalogs/product/changeStatus', updateData)
        .then((result) => {
          this.$emit('updated-info', this.selectedProduct.serial_number);
          this.$emit('success', 'Informacion actualizada');
        })
        .catch((error) => {
          this.$emit('error', error);
        });

    },
    loadProduct() {
      const config = {
        params: {
          serial_number: this.product.serial_number,
          product_avg_id: this.product.product_id,
        },
      };
      const that = this;
      this.axios.get('/catalogs/product/fixedStats', config)
        .then((result) => {
          that.selectedProduct = Object.assign({}, result.data);
          this.axios.post('/catalogs/product/search/detail?thumb=80x80', config.params)
            .then((detail) => {
              that.products = detail.data.products;
              that.pictures = detail.data.pictures;
              that.sortByWeigthDesc();
              that.newPrice.pesosPrice = that.selectedProduct.pesos_price;
              that.newPrice.dollarPrice = that.selectedProduct.dollar_price;
            }, error => {
              that.products = []
              that.pictures = []
              that.newPrice.pesosPrice = 0.00
              that.newPrice.dollarPrice = 0.00
            });
        });
    },
    setStep(step) {
      this.$emit('set-step', step);
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.newPrice.pesosPrice = this.selectedProduct.avg_price;
        this.newPrice.dollarPrice = this.selectedProduct.dll_avg_price;
      }, 300);
    },
    updatePrice() {
      const parameters = {
        id: this.product.product_id,
        pesosPrice: this.newPrice.pesosPrice,
        dollarPrice: this.newPrice.dollarPrice,
      };
      this.axios.put('/catalogs/products/manuallyUpdateAvgPrice', parameters)
        .then((result) => {
          this.selectedProduct = result.data.updatedProduct;
          this.selectedProduct.avg_price = this.selectedProduct.pesos_price;
          this.dialog = false;
          this.$emit('updated-info', this.selectedProduct.serial_number);
          this.$emit('success', 'Informacion actualizada con exito');
        })
        .catch((err) => {
          this.$emit('error', err.response.data.message);
        });
    },
    closeDescription() {
      this.descriptionDialog = false;
    },
    async updateDescription() {
      await changeDescription(this.selectedProduct.product_id, this.selectedProduct.description);
    },

    async removeMark() {
      if (this.selectedProduct.manual_update) {
        alert('Eliminar la marca');
        const parameters = {
          serial_number: this.selectedProduct.serial_number,
        };
        this.axios.put('/catalogs/product/removeManualUpdateMark', parameters)
          .then((result) => {
            this.selectedProduct.manual_update = false;
            this.$emit('success', 'Informacion actualizada');
          })
          .catch((error) => {
            this.$emit('error', error);
          });
      }
    },
  },
};
</script>
